"use strict";

exports.__esModule = true;
exports.default = validateField;
function validateField(value) {
  var validations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var otherValues = arguments[2];

  var validation = validations.find(function (validation) {
    return !!validation(value, otherValues);
  });

  return validation ? validation(value, otherValues) : null;
}
module.exports = exports["default"];